import { render } from "./auditControls.vue?vue&type=template&id=63661d40&scoped=true&ts=true"
import script from "./auditControls.vue?vue&type=script&lang=ts"
export * from "./auditControls.vue?vue&type=script&lang=ts"

import "./auditControls.vue?vue&type=style&index=0&id=63661d40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63661d40"]])

export default __exports__